// extracted by mini-css-extract-plugin
export default {"clickableCardWithPopup":"_3ygFMw_3fbrrB5ry-81ZQQ"};